import { useRef } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";

const SITEKEY = process.env.REACT_APP_HCAPTCHA_SITEKEY || "10000000-ffff-ffff-ffff-000000000001";

export default function HCaptchaField({ onVerify, onExpire, onError, captchaRef }) {
  const internalRef = useRef(null);
  const ref = captchaRef || internalRef;

  return (
    <div className="flex justify-start" data-testid="hcaptcha-widget">
      <HCaptcha
        ref={ref}
        sitekey={SITEKEY}
        onVerify={onVerify}
        onExpire={onExpire || (() => {})}
        onError={onError || (() => {})}
        theme="dark"
      />
    </div>
  );
}
